import { ThemeConfig } from '.'

export const THEMES = [
  {
    id: 'zealous',
    name: 'Zealous',
    config: {
      colors: { primary: '#000000', secondary: '#FFFFFF', accent: '#F11F84' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'tangerine',
    name: 'Tangerine',
    config: {
      colors: { primary: '#FFFFFF', secondary: '#000000', accent: '#FF9900' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'mocha',
    name: 'Mocha',
    config: {
      colors: { primary: '#FBF1E5', secondary: '#000000', accent: '#A88768' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'royal',
    name: 'Royal',
    config: {
      colors: { primary: '#151C60', secondary: '#FFFFFF', accent: '#cfb279' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'lilac',
    name: 'Lilac',
    config: {
      colors: { primary: '#EBD8EE', secondary: '#000000', accent: '#7900B1' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'submarine',
    name: 'Submarine',
    config: {
      colors: { primary: '#202E2D', secondary: '#FFFFFF', accent: '#FAFF00' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'turquoise',
    name: 'Turquoise',
    config: {
      colors: { primary: '#043224', secondary: '#FFFFFF', accent: '#6CEEBF' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'spring',
    name: 'Spring',
    config: {
      colors: { primary: '#FFFFFF', secondary: '#384A10', accent: '#69AC13' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'light',
    name: 'Light',
    config: {
      colors: { primary: '#FFFFFF', secondary: '#000000', accent: '#000000' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
  {
    id: 'dark',
    name: 'Dark',
    config: {
      colors: { primary: '#000000', secondary: '#FFFFFF', accent: '#FFFFFF' },
      fonts: { primary: 'Red Hat Display' },
    },
  },
] as const satisfies { id: string; name: string; config: ThemeConfig }[]
